import { render, staticRenderFns } from "./StudentInGroupForm.vue?vue&type=template&id=58423ae8"
import script from "./StudentInGroupForm.vue?vue&type=script&lang=js"
export * from "./StudentInGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports